<template>
<v-card-text>
  <v-switch :label="`${$t('schema.builder.inputs.options.required')}`" v-model="required"></v-switch>
  <v-switch :label="`${$t('validator.advanced')}`" v-model="expanded"></v-switch>
  <div v-if="expanded">
    <div style="margin-top:4rem" :key="index" v-for="(validator, index) in validators">
      <h4 class="text-xs-center">{{$t('validator.validator')}} {{ index + 1 }}</h4>
      <div class="value">
        <v-layout>
          <v-flex xs4 offset-xs1>
            <v-text-field type="number" :label="`${$t('validator.min')}`" v-model="validator.values.min"></v-text-field>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-text-field xs5 offset-xs1 type="number" :label="`${$t('validator.max')}`" v-model='validator.values.max'></v-text-field>
          </v-flex>
        </v-layout>
      </div>

      <v-switch :label="`${$t('validator.depend')}`" v-model="validator.depend"></v-switch>
      <div v-if="validator.depend==true" id="depend">
        <v-layout :key="keyDep +'D'" v-for="(depend, keyDep) in validator.depends" class="Depends">
          <v-flex xs4 sm4 offset-xs1>
            <v-select :items="fields" v-model="depend.field" :label="`${$t('Pole formularza')}`" item-text="name" item-value="id" required>
            </v-select>
          </v-flex>
          <v-flex xs4 sm4 offset-xs1>
            <v-text-field v-model="depend.value" :label="`${$t('archive.filter.phrase')}`" required></v-text-field>
          </v-flex>
          <v-flex xs1 sm1>
            <v-btn @click="removeDepend(index, keyDep)" v-if="keyDep!=0" fab small block>
              <v-icon small>remove</v-icon>
            </v-btn>
          </v-flex>
          <v-flex v-if="keyDep == ( validator.depends.length -1)" xs1 sm1>
            <v-btn fab small @click="addDepends(index)">
              <v-icon small>add</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>

      <!-- <v-switch :label="`${$t('schema.builder.inputs.options.show_correct')}`" v-model="validator.levels.correct"></v-switch> -->
      <v-switch :label="`${$t('validator.alarm_levels')}`" v-model="validator.levels.advanced"></v-switch>

      <div id="alerts" v-if="validator.levels.advanced">
        <v-layout :key="keyAlert +'A'" v-for="(alert, keyAlert) in validator.levels.ranges.alert">
          <h5>Alert</h5>
          <v-flex xs4 offset-xs1>
            <v-text-field type="number" v-model="alert.from" label="Min" xs12></v-text-field>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-text-field type="number" label="Max" v-model="alert.to" xs12></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn small fab v-if="keyAlert == validator.levels.ranges.alert.length -1" @click="addLevel(index, 'alert')">+ </v-btn>
          </v-flex>
        </v-layout>
        <v-layout :key="keyWarning +'W'" v-for="(warning, keyWarning) in validator.levels.ranges.warning">
          <h5>Warning</h5>
          <v-flex xs4 offset-xs1>
            <v-text-field v-model="warning.from" type="number" label="Min" xs12></v-text-field>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-text-field label="Max" type="number" v-model="warning.to" xs12></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn small fab v-if="keyWarning == validator.levels.ranges.warning.length -1" @click="addLevel(index, 'warning')">+ </v-btn>
          </v-flex>
        </v-layout>
        <v-layout :key="keyCritical +'C'" v-for="(critical, keyCritical) in validator.levels.ranges.critical">
          <h5>Critical</h5>
          <v-flex xs4 offset-xs1>
            <v-text-field type="number" v-model="critical.from" label="Min" xs12></v-text-field>
          </v-flex>
          <v-flex xs4 offset-xs1>
            <v-text-field label="Max" type="number" v-model="critical.to" xs12></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn small fab v-if="keyCritical == validator.levels.ranges.critical.length -1" @click="addLevel(index, 'critical')">+ </v-btn>
          </v-flex>
        </v-layout>
      </div>

      <v-layout>
        <v-flex v-if="index != 0" xs5>
          <v-btn @click="removeValidator(index)">
            Usun walidator
          </v-btn>
        </v-flex>
        <v-flex @click="add()" v-if="index == (validators.length -1)" xs5>
          <v-btn>
            Dodaj kolejny
          </v-btn>
        </v-flex>
      </v-layout>


    </div>
  </div>

</v-card-text>
</template>
<script>
import options from "@/mixins/options"
import Context from '@/plugins/Context'
import FieldReader from '@/plugins/FieldReader'
import fieldType from '@/enums/fieldType'

export default {
  name: "formule-options",
  mixins: [options],
  computed: {
    fields() {
      if (this.context == undefined) return []
      let fields = this.context.getFields()
      return this.reader.getFlattenedFields(fields.filter(field => field.id != this.id))
    }
  },
  data() {
    return {
      reader: new FieldReader(),
      required: undefined,
      expanded: false,
      validators: []

    }
  },
  created() {
    if (this.options != null && this.options != undefined) {
      this.required = this.options.required
      this.expanded = this.options.expanded
      this.validators = this.options.validators ? this.options.validators : []
    } else {
      this.validators = []
    }
    this.reader.addExcludedFieldType(fieldType.DEPEND)
    this.reader.addExcludedFieldType(fieldType.TABLE)
    this.reader.addExcludedFieldType(fieldType.PHOTO)
    this.reader.addExcludedFieldType(fieldType.SIGNATURE)
    this.reader.addExcludedFieldType(fieldType.ARCHIVE)
    this.add()
  },
  methods: {
    addLevel(indexValidator, level) {
      this.validators[indexValidator].levels.ranges[level].push({
        from: "",
        to: ""
      })
    },
    addDepends(index) {
      this.validators[index].depends.push({
        field: "",
        value: ""
      })
    },
    removeValidator(i) {
      this.validators.splice(i, 1);
    },
    removeDepend(indexValidator, indexDep) {
      this.validators[indexValidator].depends.splice(indexDep, 1);
    },
    updateValidators() {
      let validators = this.validators
      if (!this.expanded) {
        validators = []
      }

      this.update({
        expanded: !!this.expanded,
        validators: validators
      })
    },
    add() {
      this.updateValidators()
      this.validators.push({
        depends: [{
          field: null,
          value: null,
        }],
        values: {
          min: null,
          max: null
        },
        levels: {
          correct: true,
          advanced: false,
          ranges: {
            alert: [{
              from: null,
              to: null
            }],
            warning: [{
              from: null,
              to: null
            }],
            critical: [{
              from: null,
              to: null
            }]
          }
        }
      })
    }
  },
  watch: {
    expanded: function(val) {
      this.updateValidators()
    },
    validators: {
      handler: function(val) {
        this.updateValidators()
      },
      deep: true
    },
    required: function(val) {
      this.update({
        required: val
      })
    }
  }
}
</script>
<style>
</style>
